/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Title, Switch, ToolTip } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/ads/placement/rail/rail_placement_styles';



/* ========== ~~~~~~~~~~ EMBED ADS RAIL PLACEMENT ~~~~~~~~~~ ========== */
class RailPlacement extends Component {
    handleToggle = (toggledAd) => {
        const currentAdsState = this.props.embedStatus.ads.desktop;
        const hasTwoSelectedAds = currentAdsState.ad1 && currentAdsState.ad2;
        const hasNoSelectedAds = !currentAdsState.ad1 && !currentAdsState.ad2;
        const hasOverlayAd = currentAdsState.overlay;
        const newAdsState = { ad1: currentAdsState.ad1, overlay: currentAdsState.overlay, ad2: currentAdsState.ad2 };
        let toggleToggle = true;
        // handle overlay cases
        if (toggledAd === 'overlay') {
            if (!hasOverlayAd) {
                if (hasTwoSelectedAds) {
                    newAdsState['ad2'] = false;
                }
                if (hasNoSelectedAds) {
                    newAdsState['ad1'] = true;
                }
            } else {
                newAdsState['ad1'] = true;
                newAdsState['ad2'] = true;

                this.props.sendMessage(`You must always have two ads showing. We've toggled the other ad on for you 😀`);
            }
        } else {
            if (hasOverlayAd) {
                if (toggledAd === 'ad1') {
                    if (currentAdsState.ad1) {
                        newAdsState['ad2'] = true;
                    } else {
                        newAdsState['ad2'] = false;
                    }
                } else {
                    if (currentAdsState.ad2) {
                        newAdsState['ad1'] = true;
                    } else {
                        newAdsState['ad1'] = false;
                    }
                }
            } else {
                if (hasTwoSelectedAds) {
                    toggleToggle = false;
                    newAdsState['ad1'] = true;
                    newAdsState['ad2'] = true;
                    this.props.sendMessage(`Sorry, two ad types must always be showing. You can't toggle this off 😀`);
                }
            }
        }
        // toggle passed ad
        if (toggleToggle) { newAdsState[toggledAd] = !newAdsState[toggledAd]; } // toggle whether ad is turned on or off
        this.props.setAds(newAdsState.ad1, newAdsState.ad2, newAdsState.overlay);
    }
    checkToggleStatus = (adToToggle) => {
        return this.props.embedStatus.ads.desktop[adToToggle] ? 'on' : 'off';
    }
    render() {
        return(
            <div className={`${this.props.classes.rail} placement-location rail`}>
                <Title>
                    <h3>Desktop</h3>
                </Title>
                <div className={`visual`}>
                    <div className={`device desktop`}>
                        <div className={`embed-container`}>
                            <ToolTip position={`right`} trigger={`click`} open delay={2500} content={`250px`} zIndex={2}>
                                <div onClick={()=>this.handleToggle('ad1')} className={`ad inline ${this.checkToggleStatus('ad1')}`}>
                                    <div className={`group`}>
                                        <div className={`desc`}>Display Ad 1</div>
                                        <Switch isStatic={true} handleClick={null} value={`ad1`} on={this.checkToggleStatus('ad1')} variant={'secondary'} />
                                    </div>
                                </div>
                            </ToolTip>
                            <ToolTip position={`right`} trigger={`click`} open delay={2500} content={`350px`} zIndex={2}>
                                <div className={`embed`}>
                                    <div onClick={()=>this.handleToggle('overlay')} className={`ad overlay ${this.checkToggleStatus('overlay')}`}>
                                        <div className={`group`}>
                                            <div className={`desc`}>Overlay Ad</div>
                                            <div className={`note`}>Will only appear <span className={`clump`}>15 Sec.</span></div>
                                            <Switch isStatic={true} handleClick={null} value={`overlay`} on={this.checkToggleStatus('overlay')} variant={'secondary'} />
                                        </div>
                                    </div>
                                </div>
                            </ToolTip>
                            <ToolTip position={`right`} trigger={`click`} open delay={2500} content={`250px`} zIndex={2}>
                                <div onClick={()=>this.handleToggle('ad2')} className={`ad inline ${this.checkToggleStatus('ad2')}`}>
                                    <div className={`group`}>
                                        <div className={`desc`}>Display Ad 2</div>
                                        <Switch isStatic={true} handleClick={null} value={`ad2`} on={this.checkToggleStatus('ad2')} variant={'secondary'} />
                                    </div>
                                </div>
                            </ToolTip>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(RailPlacement);
